import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from 'common/components/PageTitle';
import { Loader } from 'common/components/Loader';
import { BasePage } from 'hydra/pages/BasePage';

const OrganisationLogContent = lazy(() =>
    import('organisation/components/OrganisationLogContent').then((m) => ({
        default: m.OrganisationLogContent,
    }))
);

export const OrganisationLogPage = () => {
    const [translate] = useTranslation();

    return (
        <BasePage contentContainerMaxWidth="lg">
            <PageTitle>
                {translate('organisationLogPage.browserTitle')}
            </PageTitle>

            <Suspense fallback={<Loader />}>
                <OrganisationLogContent />
            </Suspense>
        </BasePage>
    );
};
